<template>
  <div>
    <a-modal v-model="visible" width="660px" title="执行任务" ok-text="确认" cancel-text="取消" @ok="submit" @cancel="close">
      <a-form-model ref="modalForm" :model="modalForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="任务名称">
          <a-input v-model="modalForm.name" :disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="执行器">
          <a-input v-model="modalForm.handler" :disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="执行参数" prop="params">
          <a-textarea v-model="modalForm.params" :rows="5" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { schedulerRun } from '@/api/system/scheduler';
export default {
  name: 'SchedulerRunModal',
  props: {
    schedulerForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: this.isShow,
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      modalForm: {
        id: null,
        name: null,
        handler: null,
        params: null
      },
      rules: {
        params: [{ required: true, message: '请输入任务执行参数', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
    },
    schedulerForm() {
      this.modalForm = this.schedulerForm;
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
    async submitData() {
      const { code, message } = await schedulerRun({ scheduler_id: this.modalForm.id, scheduler_params: this.modalForm.params });
      if (code === 2000) {
        this.$message.success('任务触发成功，请稍后查看结果');
        this.close();
      } else {
        this.$message.warning(message);
      }
    },
    async submit() {
      this.$refs.modalForm.validate(valid => {
        if (valid) {
          this.submitData();
        }
      });
    }
  }
};
</script>
